import gql from 'graphql-tag'

export default gql`
	query gerOrderGroups {
		cashAssist {
			getAppConfigAdditional {
				filterOrderGroups {
					name
					value
				}
			}
		}
	}
`
